import React, { useLayoutEffect } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import { isCloudPosPaymentRequest } from "utils"
import classes from "./CheckoutSendPrintCustomerReceiptToPos.module.scss"

const CheckoutSendPrintCustomerReceiptToPos = (props) => {
  const {
    cashTypes,
    sendPrintCustomerReceiptToPos,
    setSendPrintCustomerReceiptToPos
  } = props

  const [t, i18n] = useTranslation()

  const handleCheck = (checked) => {
    setSendPrintCustomerReceiptToPos(checked)

    localStorage.setItem("printCustomerReceiptToPos", String(checked))
  }

  const cloudPosPaymentRequest =
    isCloudPosPaymentRequest(cashTypes)

  const initialCheckboxValue = () => {
    const printCustomerReceiptToPos =
      localStorage.getItem("printCustomerReceiptToPos")

    if (printCustomerReceiptToPos === null) return

    setSendPrintCustomerReceiptToPos(
      printCustomerReceiptToPos === "true"
    )
  }

  useLayoutEffect(() => {
    initialCheckboxValue()
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!cloudPosPaymentRequest) return null

  return (
    <div className={classes["print"]}>
      <Checkbox
        checked={sendPrintCustomerReceiptToPos}
        onChange={handleCheck}
      />
      <span
        className={clsx(
          classes["print-label"],
          isLtr && classes["print-label-ltr"]
        )}
      >
        {t("پرینت_رسید_در_کارتخوان")}
      </span>
    </div>
  )
}

export default CheckoutSendPrintCustomerReceiptToPos